import { StatusCode } from "api/protocols";
import { GetWaitlist } from "api/rpc/guest/teesheet/waitlist";
import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router";

interface IParams {
  waitlistId: string;
}

export default function ClientPortalWaitlist() {
  const { waitlistId } = useParams<IParams>();
  const history = useHistory();

  async function loadWaitlistInfo() {
    const resp = await GetWaitlist({ waitlist_id: waitlistId }, true);

    if (resp.status !== StatusCode.OK) {
      const url = `/tee-on/portal/login`;
      history.push(url);
      return;
    }

    const facilityShortName = resp.data?.facility?.short_name ?? "";
    const clientShortName = resp.data?.facility?.client?.short_name ?? "";

    const params = new URLSearchParams();
    params.set("date", String(resp.data?.start_date));
    params.set("waitlist_reference_id", String(resp.data?.waitlist_id));

    const url = `/portal/${clientShortName}/teetimes/${facilityShortName}?${params.toString()}`;
    history.push(url);
  }

  useEffect(() => {
    void loadWaitlistInfo();
  }, []);

  return <div></div>;
}
